var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaili(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0118 15.1537L30.1256 21.5475V8.48999L20.0118 15.1537Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.125 8.48999V21.5475L10.2388 15.1537L0.125 8.48999Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2503 4.6875H2.00027C1.06464 4.6875 0.322144 5.385 0.181519 6.28313L15.1253 16.1287L30.069 6.28313C29.9284 5.385 29.1859 4.6875 28.2503 4.6875Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.293 16.2864L15.6398 18.0339C15.4823 18.137 15.3042 18.1877 15.1242 18.1877C14.9442 18.1877 14.7661 18.137 14.6086 18.0339L11.9555 16.2845L0.184204 23.7302C0.328579 24.6208 1.06733 25.3127 1.9992 25.3127H28.2492C29.1811 25.3127 29.9198 24.6208 30.0642 23.7302L18.293 16.2864Z",
    fill: "#7A297F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.125)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaili);
export default __webpack_public_path__ + "static/media/maili.4cdb271d8a183924c30ca685bec1fbe8.svg";
export { ForwardRef as ReactComponent };